export enum PriorityQueryKey {
  Primary = 'primary',
  Secondary = 'secondary',
}

export enum TypeQueryKey {
  Viewer = 'viewer',
  Count = 'count',
  Color = 'color',
}

export enum SectionQueryKey {
  Assignments = 'assignments',
  AssignmentsSearch = 'assignments-search',
  Control = 'controls',
  Document = 'document',
  Counterparty = 'counterparty',
}
